var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ref, createRef } from 'lit/directives/ref.js';

var NinjaHeader = /*#__PURE__*/function (_LitElement) {
  _inherits(NinjaHeader, _LitElement);

  var _super = _createSuper(NinjaHeader);

  function NinjaHeader() {
    var _this;

    _classCallCheck(this, NinjaHeader);

    _this = _super.apply(this, arguments);
    _this.placeholder = '';
    _this.hideBreadcrumbs = false;
    _this.breadcrumbHome = 'Home';
    _this.breadcrumbs = [];
    _this._inputRef = createRef();
    return _this;
  }

  _createClass(NinjaHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var breadcrumbs = '';

      if (!this.hideBreadcrumbs) {
        var itemTemplates = [];

        var _iterator = _createForOfIteratorHelper(this.breadcrumbs),
            _step;

        try {
          var _loop = function _loop() {
            var breadcrumb = _step.value;
            itemTemplates.push(html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<button\n            tabindex=\"-1\"\n            @click=", "\n            class=\"breadcrumb\"\n          >\n            ", "\n          </button>"])), function () {
              return _this2.selectParent(breadcrumb);
            }, breadcrumb));
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        breadcrumbs = html(_templateObject || (_templateObject = _taggedTemplateLiteral(["<div class=\"breadcrumb-list\">\n        <button\n          tabindex=\"-1\"\n          @click=", "\n          class=\"breadcrumb\"\n        >\n          ", "\n        </button>\n        ", "\n      </div>"])), function () {
          return _this2.selectParent();
        }, this.breadcrumbHome, itemTemplates);
      }

      return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", "\n      <div part=\"ninja-input-wrapper\" class=\"search-wrapper\">\n        <input\n          part=\"ninja-input\"\n          type=\"text\"\n          id=\"search\"\n          spellcheck=\"false\"\n          autocomplete=\"off\"\n          @input=\"", "\"\n          ", "\n          placeholder=\"", "\"\n          class=\"search\"\n        />\n      </div>\n    "])), breadcrumbs, this._handleInput, ref(this._inputRef), this.placeholder);
    }
  }, {
    key: "setSearch",
    value: function setSearch(value) {
      if (this._inputRef.value) {
        this._inputRef.value.value = value;
      }
    }
  }, {
    key: "focusSearch",
    value: function focusSearch() {
      var _this3 = this;

      requestAnimationFrame(function () {
        return _this3._inputRef.value.focus();
      });
    }
  }, {
    key: "_handleInput",
    value: function _handleInput(event) {
      var input = event.target;
      this.dispatchEvent(new CustomEvent('change', {
        detail: {
          search: input.value
        },
        bubbles: false,
        composed: false
      }));
    }
  }, {
    key: "selectParent",
    value: function selectParent(breadcrumb) {
      this.dispatchEvent(new CustomEvent('setParent', {
        detail: {
          parent: breadcrumb
        },
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      this.focusSearch();
    }
  }, {
    key: "_close",
    value: function _close() {
      this.dispatchEvent(new CustomEvent('close', {
        bubbles: true,
        composed: true
      }));
    }
  }]);

  return NinjaHeader;
}(LitElement);

NinjaHeader.styles = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    :host {\n      flex: 1;\n      position: relative;\n    }\n    .search {\n      padding: 1.25em;\n      flex-grow: 1;\n      flex-shrink: 0;\n      margin: 0px;\n      border: none;\n      appearance: none;\n      font-size: 1.125em;\n      background: transparent;\n      caret-color: var(--ninja-accent-color);\n      color: var(--ninja-text-color);\n      outline: none;\n    }\n    .search::placeholder {\n      color: var(--ninja-placeholder-color);\n    }\n    .breadcrumb-list {\n      padding: 1em 4em 0 1em;\n      display: flex;\n      flex-direction: row;\n      align-items: stretch;\n      justify-content: flex-start;\n      flex: initial;\n    }\n\n    .breadcrumb {\n      background: var(--ninja-secondary-background-color);\n      text-align: center;\n      line-height: 1.2em;\n      border-radius: var(--ninja-key-border-radius);\n      border: 0;\n      cursor: pointer;\n      padding: 0.1em 0.5em;\n      color: var(--ninja-secondary-text-color);\n      margin-right: 0.5em;\n      outline: none;\n    }\n\n    .search-wrapper {\n      display: flex;\n      border-bottom: var(--ninja-separate-border);\n    }\n  "])));

__decorate([property()], NinjaHeader.prototype, "placeholder", void 0);

__decorate([property({
  type: Boolean
})], NinjaHeader.prototype, "hideBreadcrumbs", void 0);

__decorate([property()], NinjaHeader.prototype, "breadcrumbHome", void 0);

__decorate([property({
  type: Array
})], NinjaHeader.prototype, "breadcrumbs", void 0);

NinjaHeader = __decorate([customElement('ninja-header')], NinjaHeader);
export { NinjaHeader };